export const _Buttons = {
  ADD: "ADD",
  CANCEL: "CANCEL",
  CLOSE: "CLOSE",
  DELETE: "DELETE",
  RESET: "RESET",
  SAVE: "SAVE",
  UNCLAIM: "UNCLAIM",
};

// MODALS
export const MODAL = {
  REPORTS: {
    ADD: "ADD REPORT",
    EDIT: "EDIT REPORT",
  },
  TEMPLATES: {
    ADD: "ADD TEMPLATE",
    EDIT: "EDIT TEMPLATE",
  },
  CONTROLLER: {
    EDIT: "EDIT APPLIANCE",
  },
};

// CONTROLLERS
export const CONTROLLER = {
  TOOLS: {
    AQUATIC_PROFILES: "Aquatic Profiles",
    CELLULAR_MODEM: "Cellular Modem",
    EMAIL_TRANSMISSION: "Email Transmission",
    ETHERNET: "Ethernet",
    MODBUS: "Modbus TCP/IP",
    PORT_FORWARDING: "Port Forwarding",
  },
};
